module.exports = __webpack_public_path__ + "img/bosch-logo.90971c90.png";